module.exports = __webpack_public_path__ + "img/hero-safe.00355f2.svg";